import React, { useEffect } from "react";
import CareerSection from "../components/Career/CareerSection";
import { Banner } from "../components/common/Banner";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getCareerData } from "../features/Career";
import { Loader } from "../components/common/Loader";


const Career: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { career_data, careerLoader, status } = useAppSelector((state) => state.career);

    useEffect(() => {
        dispatch(getCareerData());
    }, [dispatch, status])

    if (careerLoader) {
        return <Loader />;
    }
    return (
        <>
            <Banner banner_title={banner_title} />
            <CareerSection career_data={career_data} />
        </>
    )
}
export default Career;